import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Warning32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'light' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={`${icon}-32`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M16,4.2125 C22.5100565,4.2125 27.7875,9.48994351 27.7875,16 C27.7875,22.5100565 22.5100565,27.7875 16,27.7875 C9.48994351,27.7875 4.2125,22.5100565 4.2125,16 C4.2125,9.48994351 9.48994351,4.2125 16,4.2125 Z M17,19 L15,19 L15,21.3535356 L17,21.3535356 L17,19 Z M17,10 L15,10 L15,17.3535356 L17,17.3535356 L17,10 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Warning32;
